import React, { useState, useEffect } from "react";

// reactstrap
import { Row, Col } from "reactstrap";

// animations
import Fade from "react-reveal/Fade";
import Pulse from "react-reveal/Pulse";

// react scroll
import { Link } from "react-scroll";

const HomeNav = ({ links }) => {
  return (
    <div className="d-none d-md-block d-xl-block d-xl-none">
      <Row className="ml-auto mr-auto home-nav justify-content-center">
        {links.map((link, idx) => {
          return (
            <Col md="2" xl="2" key={idx}>
              <Link to={link.path} smooth={true} className="home-link">
                {link.title}
              </Link>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

const Home = () => {
  const [userName, setUserName] = useState("");

  const links = [
    {
      title: "ABOUT",
      path: "about",
    },
    {
      title: "SKILLS",
      path: "skills",
    },
    {
      title: "PORTFOLIO",
      path: "projects",
    },
    {
      title: "CONTACT",
      path: "contact",
    },
  ];

  useEffect(() => {
    const sessionName = window.sessionStorage.getItem("uName");
    if (sessionName !== null) {
      setUserName(sessionName);
    }
  }, []);

  return (
    <div className="home-container">
      <Fade up>
        <div className="text-center w-100">
          <Pulse delay={1000}>
            <h1 className="home-container-greeting">
              Hello {userName === "" ? "there" : userName}!
            </h1>
          </Pulse>
          <div className="home-container-message">
            I am <span className="main-text-color">Mark Galisa</span>. I develop
            systems and websites.
          </div>
          <HomeNav links={links} />
        </div>
      </Fade>
    </div>
  );
};

export default Home;
